import { api } from './client';
import type { Page } from './catalogs';
import type { CancellableState } from './cancellation';

export interface GoodsTransferItem {
  id?: string;
  line_number: number;
  nomenclature_id: string;
  characteristic_id?: string | null;
  series_id?: string | null;
  quantity: string;
  cost_amount?: string;
}

export interface GoodsTransferListItem {
  id: string;
  organization_id: string;
  document_number: string;
  document_date: string;
  warehouse_from_id: string;
  warehouse_to_id: string;
  total_quantity: string;
  total_amount: string;
  posted: boolean;
  deletion_mark: boolean;
  external_source?: string | null;
  // Block 5.3b:
  state?: CancellableState;
}

export interface GoodsTransfer extends GoodsTransferListItem {
  posted_at: string | null;
  comment: string | null;
  items: GoodsTransferItem[];
  // Block 5.3b:
  cancelled_at?: string | null;
  cancellation_reason?: string | null;
}

export interface GoodsTransferCreate {
  organization_id: string;
  document_number: string;
  document_date: string;
  warehouse_from_id: string;
  warehouse_to_id: string;
  comment?: string | null;
  items: GoodsTransferItem[];
}

export type GoodsTransferUpdate = Partial<GoodsTransferCreate>;

export const goodsTransfers = {
  list: (params?: {
    organization_id?: string;
    warehouse_from_id?: string;
    warehouse_to_id?: string;
    posted?: boolean;
    limit?: number;
    offset?: number;
  }) =>
    api.get<Page<GoodsTransferListItem>>('/goods-transfers', { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<GoodsTransfer>(`/goods-transfers/${id}`).then((r) => r.data),
  create: (payload: GoodsTransferCreate) =>
    api.post<GoodsTransfer>('/goods-transfers', payload).then((r) => r.data),
  update: (id: string, payload: GoodsTransferUpdate) =>
    api.patch<GoodsTransfer>(`/goods-transfers/${id}`, payload).then((r) => r.data),
  remove: (id: string) =>
    api.delete(`/goods-transfers/${id}`).then(() => undefined),
  post: (id: string) =>
    api.post<GoodsTransfer>(`/goods-transfers/${id}/post`).then((r) => r.data),
  unpost: (id: string) =>
    api.post<GoodsTransfer>(`/goods-transfers/${id}/unpost`).then((r) => r.data),
  cancel: (id: string, reason: string) =>
    api.post(`/goods-transfers/${id}/cancel`, { cancellation_reason: reason }).then((r) => r.data),
};
